export function scrollTo(selector) {
  document.querySelector(selector).scrollIntoView({
    behavior: "smooth"
  });
}
export function toggleLegend() {
  document.querySelector(".search-legend").classList.toggle("--closed");
}